/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoginLogo from "../assets/img/brand-icon.png";
import { useHistory } from "react-router-dom";
import {
  setToken,
  setUserData,
  showToast,
  setLocation,
  setUserRole,
} from "../redux/auth/auth.action";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import Footer from "../comman/component/footer";
import { userForgotPassword } from "../services/user";
import { toast, ToastContainer } from "react-toastify";

const ForgotPasswordPage = () => {
  const history = useHistory();
  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is Required"),
  });

  const submitFunction = async (value) => {
    // const data = {
    //   token,
    //   password: value.password,
    // };
    // const userId = user.userId;
    // const response = await updateUserPassword(token, data);
    // console.log(response, "response");
  };
  const handleForgotEmail = async (e) => {
    const response = await userForgotPassword(e.email, e);

    if (response.status === 204) {
      toast("Mail Sent Successfully.Please Check your mail.");
    } else {
      toast("Email is not valid.");
    }
  };
  return (
    <div id="pageWrapper">
      <section className="sign-in-sec">
        <div className="login-content-wrapper">
          <div className="login-content-inner">
            <div className="img">
              <img src={LoginLogo} alt="" />
            </div>
            <div className="login-fileds">
              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(value) => submitFunction(value)}
              >
                {({ submitForm, values }) => (
                  <Form>
                    <div className="login-form">
                      <div className="input-item">
                        <Field
                          type="email"
                          name="email"
                          placeholder="Enter Email"
                        />
                      </div>
                      <ErrorMessage name="email">
                        {(msg) => (
                          <span className="fm_error" style={{ color: "red" }}>
                            {msg}
                          </span>
                        )}
                      </ErrorMessage>
                      <div className="input-item login">
                        <button onClick={() => handleForgotEmail(values)}>
                          Submit
                        </button>
                      </div>
                      <div className="input-item login forget-password">
                        <span type="button" onClick={() => history.push('/')}>
                          Back to login
                        </span>
                      </div>
                      <ToastContainer
                        position="top-right"
                        // autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        limit={1}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <div className="website-about-links">
            <a
              href="https://ringerinteractive.com/privacy-policy/"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
            {" | "}
            <a
              href="https://ringerinteractive.com/terms-and-conditions/"
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>
            {" | "}
            <a
              href="https://ringerinteractive.com/eula/"
              target="_blank"
              rel="noreferrer"
            >
              License Agreement
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setToken: (data) => dispatch(setToken(data)),
  setUserData: (data) => dispatch(setUserData(data)),
  setToaster: (data) => dispatch(showToast(data)),
  setLocation: (data) => dispatch(setLocation(data)),
  setUserRole: (data) => dispatch(setUserRole(data)),
});

export default connect(null, mapDispatchToProps)(ForgotPasswordPage);
